import { gql } from '@apollo/client'

const GET_MERCHANTS = gql`
  query GetMerchants($filters: JSON) {
    merchants(filters: $filters) {
      collection {
        id
        createdAt
        name
        updatedAt
      }
      metadata {
        totalCount
        currentPage
        limitValue
      }
    }
  }
`

export default GET_MERCHANTS
